import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../../../actions/user";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../../actions/loadingPage";
import { LoadingPage } from "../../../LoadingPage/LoadingPage";
//Icons
import styles from "./UserAccountInfo.module.scss";
import NoProfilePic from "../../../../styles/pics/NoProfilePic2.svg";
import Confirmed from "../../../../styles/icon/Confirmed.svg";
import NotConfirmed from "../../../../styles/icon/NotConfirmed.svg";
import NotificationError from "../../../../helpers/errors_notifications/NotificationError";

export default function UserAccountInfo() {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.fullUserInfo.data_profile);
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        dispatch(showLoadingPage());
        await dispatch(userProfile());
      } catch (ex) {
      } finally {
        dispatch(hiddenLoadingPage());
      }
    };
    getUserDetails();
  }, []);
  return (
    <>
      {loadingBar && <LoadingPage />}
      <div className={styles.container}>
        <div className={`font_color_white ${styles.page_title}`}>
          اطلاعات حساب کاربری
        </div>
        <div className={styles.user_pic_profile}>
          <img src={NoProfilePic} alt="" width={70} height={70} />
        </div>
        <div className={styles.acc_info_container}>
          <div className={styles.user_name_and_verify}>
            <div className={`changeBackgroundToWhite ${styles.user_name}`}>
              <div className={styles.info}>{userInfo?.user?.fullname}</div>
              <div className={styles.title}>نام و نام خانوادگی: </div>
              <div className={styles.status}>
                {userInfo?.user?.fullname ? (
                  <img src={Confirmed} alt="" width={18} height={18} />
                ) : (
                  <img src={NotConfirmed} alt="" width={20} height={20} />
                )}
              </div>
            </div>
            <div className={`changeBackgroundToWhite ${styles.user_verify}`}>
              <div className={styles.info}>
                {userInfo?.user?.documentStatus ? "احراز شده" : "احراز نشده"}
              </div>
              <div className={styles.title}>وضعیت احراز هویت: </div>
              <div className={styles.status}>
                {userInfo?.user?.documentStatus ? (
                  <img src={Confirmed} alt="" width={18} height={18} />
                ) : (
                  <img src={NotConfirmed} alt="" width={20} height={20} />
                )}
              </div>
            </div>
          </div>
          <div className={styles.IfNotConfirmed_User}>
            <div className={styles.NotificationForVerify}>
              <NotificationError
                bgColor="rgba(44, 64, 101, 0.1)"
                fontColor="rgba(44, 64, 101, 1)"
                text="کاربر گرامی جهت واریز یا برداشت ریال نیازمند احراز هویت در سایت ارزفی می باشید جهت تبدیل ارزها(چنج)
               و استفاده از کیف پول ارزفی نیازی به احراز هویت نمی باشد"
                bgBorder="#2C4065"
              />
            </div>
            {!userInfo?.user?.documentStatus && (
              <div className={styles.buttons_container}>
                <div className={styles.button_for_verify}>
                  <Link to="/my-profile/auth-guid">راهنمای احراز هویت</Link>
                </div>
                <Link to="/my-profile/authentication">
                  <div className={styles.button_for_verify}>احراز هویت</div>
                </Link>
              </div>
            )}
          </div>
          <div className={styles.email_phone_twoStep_container}>
            <div className={`changeBackgroundToWhite ${styles.user_email}`}>
              <div className={styles.gird_temp}>
                <div className={styles.info}>{userInfo?.user?.email}</div>
                <div className={styles.title}>آدرس ایمیل:‌</div>
              </div>
              <div className={styles.status}>
                {userInfo?.user?.emailStatus ? (
                  <img src={Confirmed} alt="" width={18} height={18} />
                ) : (
                  <img src={NotConfirmed} alt="" width={20} height={20} />
                )}
              </div>
              {!userInfo?.user?.emailStatus && (
                <div className={styles.sendConfirmCode_BTN}>
                  <Link to="/my-profile/authentication">تکمیل اطلاعات</Link>
                </div>
              )}
            </div>
            <div
              className={`changeBackgroundToWhite ${styles.user_phone_container}`}
            >
              <div className={styles.gird_temp}>
                <div className={styles.info}>{userInfo?.user?.phoneNumber}</div>
                <div className={styles.title}>شماره موبایل: </div>
              </div>
              <div className={styles.status}>
                {userInfo?.user?.smsStatus ? (
                  <img src={Confirmed} alt="" width={18} height={18} />
                ) : (
                  <img src={NotConfirmed} alt="" width={20} height={20} />
                )}
              </div>
              {!userInfo?.user?.smsStatus && (
                <div className={styles.sendConfirmCode_BTN}>
                  <Link to="/my-profile/authentication">تکمیل اطلاعات</Link>
                </div>
              )}
            </div>
            <div
              className={`changeBackgroundToWhite ${styles.user_two_stepVerify}`}
            >
              <div className={styles.gird_temp}>
                <div className={styles.info}>
                  {userInfo?.user?.totpStatus ? "فعال" : "غیر فعال"}
                </div>
                <div className={styles.title}>کد شناسایی دو عاملی: </div>
              </div>
              <div className={styles.status}>
                {userInfo?.user?.totpStatus ? (
                  <img src={Confirmed} alt="" width={18} height={18} />
                ) : (
                  <img src={NotConfirmed} alt="" width={20} height={20} />
                )}
              </div>
              {!userInfo?.user?.totpStatus && (
                <div className={styles.sendConfirmCode_BTN}>
                  <Link to="/my-profile/authentication/2fa">فعال سازی</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
